// Taşeron portalı — Supplier Panosu (api-contract §28.3/§28.7) TanStack Query anahtarları.
//
// Panonun kimliği aktif firmadaki `SupplierUserCompany.ContractorId` bağından sunucuda
// çözülür (istek parametresiz — §28.3, istemci firma/contractor kimliği GÖNDERMEZ); anahtar
// yine de `companyId` taşır ki firma değişiminde (switcher → `/auth/switch-company`) sorgu
// yeniden çekilsin ve önceki firmanın verisi önbellekte kalmasın — `supplierPermitKeys` /
// `supplierContractorKeys` ile AYNI desen.

import type { SupplierActionItemCategory } from '@isgportal/shared';

export const supplierDashboardKeys = {
  /** Tüm pano sorgularının kök öneki. */
  all: () => ['supplier-dashboard'] as const,
  /** Tek firma panosu (§28.3) — parametresiz istek; yalnız firma değişince yeniden çeker. */
  dashboard: (companyId: number | null) => ['supplier-dashboard', companyId] as const,
  /**
   * Sayfalanmış + kategoriye göre süzülmüş "Eksikler" listesi (§28.7, genişletilmiş
   * `MissingItemsCard`). `companyId` + `category` + `page` + `pageSize` ANAHTARIN parçasıdır —
   * firma değişince, filtre değişince ya da sayfa değişince otomatik yeniden çeker; `dashboard`
   * anahtarından AYRIDIR (§28.7'nin `total`/`filteredTotal`'ı §28.3'ün `itemsTotal`'ından
   * ayrı bir istekten gelir, bkz. supplierDashboard.ts).
   */
  items: (
    companyId: number | null,
    category: SupplierActionItemCategory,
    page: number,
    pageSize: number,
  ) => ['supplier-dashboard', 'items', companyId, category, page, pageSize] as const,
  /**
   * Çok-firma özeti (§28.4, `CompanySwitcher`). İstek parametresizdir ve yanıt ÇOK firmayı
   * kapsar, ama anahtar yine de aktif `companyId`'yi taşır (plan S26 3.5(4)) — aktif firmadaki
   * taşeron bağı yeniden çözüldüğü için satırların tamamı firma değişiminde yeniden geçerli
   * hâle gelmek zorunda; aksi hâlde eski firmanın önbelleği yeni firmada gösterilebilir.
   */
  workspacesSummary: (companyId: number | null) =>
    ['supplier-dashboard', 'workspaces-summary', companyId] as const,
} as const;
